import React from 'react';
import cx from 'classnames';
import { FILTER_TYPE_BOOLEAN, FILTER_TYPE_LIST, FILTER_KEYS } from '../constants';
import { FilterKey, FilterValue, SearchFilters } from '../FilterTypes';
import { Motif } from '../../../types';
import { existenceCheck, getTitleCase, getLabel } from '../../utils';
import { StyledFilterPill } from '../FilterStyles.styles';
import styles from './styles.module.less';

const FilterTags = ({
  searchFilters,
  onClearAll,
  updateFilter,
  allMotifs,
  className,
}: FilterTagsProps): JSX.Element | null => {
  const filterKeys = Object.keys(FILTER_KEYS) as Array<FilterKey>;

  const activeFilters = filterKeys.filter(filter => {
    const currentValue = searchFilters[filter];
    return existenceCheck(currentValue);
  });
  const allTags: React.ReactNode[] = [];

  activeFilters.forEach(filter => {
    let clearAction: (arg?: string | null) => void;
    if (FILTER_KEYS[filter].filterType === FILTER_TYPE_BOOLEAN) {
      clearAction = () => updateFilter(filter, FILTER_KEYS[filter].defaultValue);
      allTags.push(
        <StyledFilterPill
          key={FILTER_KEYS[filter].label}
          value={FILTER_KEYS[filter].label}
          label={FILTER_KEYS[filter].label}
          handlePillClick={() => clearAction()}
        />
      );
    }

    if (FILTER_KEYS[filter].filterType === FILTER_TYPE_LIST) {
      clearAction = tagVal => {
        if (tagVal) {
          const newVal = [...(searchFilters[filter] as string[])];
          newVal.splice(
            newVal.indexOf(filter === 'silhouettes' ? tagVal.toLowerCase() : tagVal.toUpperCase()),
            1
          );
          updateFilter(filter, newVal);
        }
      };
      if (filter === 'multiColor' || filter === 'seo_colors') {
        searchFilters[filter]?.map(color =>
          allTags.push(
            <StyledFilterPill
              key={color}
              value={color}
              label={color && getLabel(color)}
              handlePillClick={() => clearAction(color.toUpperCase())}
            />
          )
        );
      } else if (filter === 'silhouettes') {
        searchFilters[filter]?.map(shape =>
          allTags.push(
            <StyledFilterPill
              key={shape}
              value={shape}
              label={shape && getTitleCase(shape)}
              handlePillClick={() => clearAction(shape.toUpperCase())}
            />
          )
        );
      } else if (filter === 'motifs') {
        if (allMotifs.length === 0) return;
        searchFilters[filter]?.forEach(style => {
          const motifLabel = allMotifs.find(motif => motif.key.toUpperCase() === style) || null;
          if (motifLabel) {
            allTags.push(
              <StyledFilterPill
                key={motifLabel.key}
                value={motifLabel.key}
                label={motifLabel.name || ''}
                handlePillClick={() => clearAction(motifLabel.key)}
              />
            );
          }
        });
      }
    }
  });

  if (allTags.length < 1) return null;

  return (
    <div className={cx(styles.tagContainer, className)}>
      {allTags.length > 1 ? (
        <div className={cx('visible-xs', styles.tagClearAll)} onClick={onClearAll}>
          Clear All
        </div>
      ) : null}
      {allTags}
      {allTags.length > 1 ? (
        <div className={cx('hidden-xs', styles.tagClearAll)} onClick={onClearAll}>
          Clear All
        </div>
      ) : null}
    </div>
  );
};

type FilterTagsProps = {
  searchFilters: SearchFilters;
  onClearAll: () => void;
  updateFilter: (filterKey: FilterKey, filterValue?: FilterValue) => void;
  allMotifs: Motif[];
  className?: string;
};

export default FilterTags;
